import Skeleton from '@mui/material/Skeleton';
import { SxProps, Theme } from '@mui/material/styles';

export default ({ sx }: { sx?: SxProps<Theme> }) => (
  <Skeleton variant="text" height={53} sx={sx} />
);
